import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import drivingSchoolStyle from '../../assets/css/driving-schools.css';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Api from '../../__helpers/api';
import SchoolsList from './SchoolsList';

//helpers
import params from '../../__helpers/params'



function DrivingSchools() {
    const history = useHistory()
    const inputLabel = useRef(null);
    const [labelWidth, setLabelWidth] = useState(0);
    const regionIdParam = params('region_id') || ''
    const regionParam = params('region') || ''
    const categoryIdParam = params('category_id') || ''
    const categoryParam = params('category') || ''

    useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth);
    }, []);

    const [location, setLocation] = useState({
        region: '',
        regions: [],
        category: '',
        categories: [],
        urlTownParams: `region=${regionParam}&region_id=${regionIdParam}`,
        urlCategoryParams: `category=${categoryParam}&category_id=${categoryIdParam}`
    });

    useEffect(() => {
        const regionsUrl = '/regions';
        Api.get(regionsUrl)
            .then(response => {
                setLocation(location => {
                    return { ...location, regions: response.data }
                });
            });

        const categoriesUrl = '/categories';
        Api.get(categoriesUrl)
            .then(response => {
                setLocation(location => {
                    return { ...location, categories: response.data }
                });

            });


    }, [])

    useEffect(() => {
        Api.get(`/categories-by-region?partners=1&region_id=${regionIdParam}`)
            .then(res => {
                setLocation(location => {
                    return {
                        ...location,
                        categories: res.data
                    }
                });
            });
    }, [categoryIdParam])

    const handleRegionChange = e => {
        const value = e?.target?.value

        const option = document.querySelector(`li[data-value="${value}"]`)

        const param = `region=${option.textContent}&region_id=${value}`

        setLocation(prev => ({
            ...prev,
            urlTownParams: param
        }))

        setParams(param, location.urlCategoryParams)
    };


    const handleCategoryChange = e => {
        const value = e.target.value

        const option = document.querySelector(`li[data-value="${value}"]`)

        const param = `category=${option.textContent}&category_id=${value}`
        setLocation(prev => ({
            ...prev,
            urlCategoryParams: param
        }))

        setParams(location.urlTownParams, param)
    };

    const setParams = (urlTownParams, urlCategoryParams) => {
        history.push(`?${urlTownParams}&${urlCategoryParams}`)
    }

    return (
        <main id="drivingSchoolsMain" className={drivingSchoolStyle}>
            <section id="schoolsBanner">

            </section>
            <section id="drivingSchools">
                <div className="wrapper">
                    <h1>
                        Автошколи
                    </h1>
                    <p>
                        Списък с учебни центрове в страната, предлагащи шофьорски курсове
                    </p>
                    <div className="schools-holder">
                        <div className="selects-holder">
                            <FormControl variant="outlined" id="region">
                                <InputLabel ref={inputLabel}>
                                    Област
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    value={regionIdParam}
                                    onChange={handleRegionChange}
                                    labelWidth={labelWidth}
                                >
                                    <MenuItem value="" disabled>
                                        <em>Избор</em>
                                    </MenuItem>
                                    {location.regions.map(region =>
                                        <MenuItem value={region.id} key={region.id}>
                                            {region.name}
                                        </MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                            <FormControl variant="outlined" id="cat">
                                <InputLabel ref={inputLabel}>
                                    Категория
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    onChange={handleCategoryChange}
                                    labelWidth={labelWidth}
                                    value={categoryIdParam}
                                >
                                    <MenuItem value="" disabled>
                                        <em>Избор</em>
                                    </MenuItem>
                                    <MenuItem value='' key='all-cats'>
                                        Всички
                                    </MenuItem>
                                    {location.categories.map(category =>
                                        <MenuItem value={category.id} key={category.id}>
                                            {category.name}
                                        </MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </div>
                        <SchoolsList
                            regionId={regionIdParam}
                            categoryId={categoryIdParam}
                        />
                    </div>
                </div>
            </section>
        </main >
    );
}

export default DrivingSchools;
